import { useState, useEffect } from 'react'
import { useHistory, Redirect } from 'react-router-dom'
import { customizeError } from './customErrors'
import { Loading } from 'Components'
import { SignUpForm } from './forms'
import LandingPage from './LandingPage'
import WeaverService from 'Services/WeaverService'

SignUp = ({ setAuth, setError }) ->

  [authenticated, setAuthenticated] = useState(false)
  [buttonText, setButtonText] = useState('Sign Up')
  [error, setError] = useState(undefined)
  [loading, setLoading] = useState(false)
  [buttonEnabled, setButtonEnabled] = useState(false)
  [selfSignUpEnabled, setSelfSignUpEnabled] = useState(false)
  [loading, setLoading] = useState(true)

  history = useHistory()

  useEffect( ->
    ( ->
      setSelfSignUpEnabled(await Weaver.getInstance().isSelfSignupEnabled())
      setLoading(false)
    )()
    undefined
  , [])

  signUp = (values) ->
    newUser = new Weaver.User()
    _.map(values, (val, key) ->
      newUser[key] = val
    )
    newUser.signUp()

  onChange = (e) ->
    setButtonEnabled(username.value isnt '' and password.value isnt '')

  getCreatedSpaceId = ->
    projs = await Weaver.Project.list()
    projs[projs.length-1].id()

  onFinish = (values) ->
    setLoading(true)
    oldButtonText = buttonText
    setButtonText(' ')
    try
      response = await signUp(values)
      localStorage.setItem('newUser', true)
      setAuthenticated(response?)
      setError(!response?)
      spaceId = await getCreatedSpaceId()
      history.push("/#{spaceId}")
    catch e
      err = customizeError(e)
      setError(err.message)
      localStorage.setItem('newUser', false)
      setLoading(false)
      setButtonText(oldButtonText)
      throw e

  if loading
    <Loading />
  else if selfSignUpEnabled isnt true
    <Redirect to="/login" />
  else
    <LandingPage error={error}>
      <SignUpForm
        onFinish={onFinish}
        onChange={onChange}
        buttonEnabled={buttonEnabled}
        loading={loading}
        buttonText={buttonText}
      />
    </LandingPage>

export default SignUp
